import { EventHandler, FormEvent } from "react";
import { RadioSelector } from "@sellar-io/components";
import { BuyerOwnershipRadioElement } from "../../components/buyerOwnershipRadioElement/BuyerOwnershipRadioElement";

export type OwnershipType = "group_managed" | "tenancy" | "independent";
export function BuyerBusinessOwnership({
  value,
  onChange,
}: {
  value: OwnershipType | undefined | null;
  onChange: EventHandler<FormEvent<HTMLInputElement>>;
}) {
  return (
    <RadioSelector onChange={onChange} value={value ?? ""}>
      <BuyerOwnershipRadioElement
        value={"group_managed"}
        title={"Group / managed"}
      />
      <BuyerOwnershipRadioElement value={"tenancy"} title={"Tenancy"} />
      <BuyerOwnershipRadioElement value={"independent"} title={"Independent"} />
    </RadioSelector>
  );
}
